import React from 'react';
import EyeLids from './cards/EyeLids';
import EyeAnatomy from './cards/EyeAnatomy';
import Pathology from './cards/Pathology';
import Cornea from './cards/Cornea';
import Cataract from './cards/Cataract';
import Glaucoma from './cards/Glaucoma';
import Vitreous from './cards/Vitreous';
import Retina from './cards/Retina';

const SECTION_NAV = [
    { id: 'eye-lids', label: 'Eye Lids', icon: 'bi-eye' },
    { id: 'eye-anatomy', label: 'Eye Anatomy', icon: 'bi-diagram-3' },
    { id: 'pathology-eyelids', label: 'Pathology', icon: 'bi-bandaid' },
    { id: 'cornea-sclera', label: 'Cornea', icon: 'bi-circle' },
    { id: 'cataract', label: 'Cataract', icon: 'bi-cloud' },
    { id: 'glaucoma', label: 'Glaucoma', icon: 'bi-bar-chart' },
    { id: 'vitreous', label: 'Vitreous', icon: 'bi-droplet' },
    { id: 'retina', label: 'Retina', icon: 'bi-bullseye' },
];

export default function EyeDrawHome() {
    return (
        <>
            <div className="ecx-page-card mb-4">
                <div className="ecx-page-panel__body">
                    <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                        <div>
                            <h6 className="mb-1 fw-semibold text-dark">Browse by category</h6>
                            <p className="mb-0 small text-muted">
                                Select a template, then draw directly on the image to explain findings to patients.
                            </p>
                        </div>
                        <nav className="eye-draw-nav" aria-label="Eye Draw categories">
                            {SECTION_NAV.map((section) => (
                                <a key={section.id} href={`#${section.id}`} className="eye-draw-nav__link">
                                    <i className={`bi ${section.icon}`}></i>
                                    {section.label}
                                </a>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>

            <EyeLids />
            <EyeAnatomy />
            <Pathology />
            <Cornea />
            <Cataract />
            <Glaucoma />
            <Vitreous />
            <Retina />
        </>
    );
}
